import { Profile, Slice } from '@ringo/types'
import { AlloyDTO } from '../generated'
import cloneDeep from 'lodash/cloneDeep'
import minBy from 'lodash/minBy'
import sumBy from 'lodash/sumBy'

const FIXED_HEIGHT_OVERSIZE_SINTERING_NORMAL = 0.4
const FIXED_WIDTH_OVERSIZE_AXIAL = 0.4

export function getSlicesWithOversize(originalSlices: Array<Slice>, alloys: AlloyDTO[], profile: Profile.Sinterring | Profile.SinterringAxial): Slice[] {
    const slices = cloneDeep(originalSlices)

    if (profile === Profile.SinterringAxial) {
        slices.forEach((slice) => {
            slice.widthOversize = FIXED_WIDTH_OVERSIZE_AXIAL
            slice.heightOversize = 0
        })
    } else {
        const lowestMeltingPointAlloy = minBy(
            alloys.filter((alloy) => slices.map((slice) => slice.alloyName).includes(alloy.materialNumber)),
            (alloy) => alloy.minMeltingPoint
        )

        slices.forEach((slice, index) => {
            if (index === 0) {
                slice.widthOversize = 0.2
            } else if (index === slices.length - 1) {
                slice.widthOversize = 0.2
            } else {
                slice.widthOversize = 0
            }

            if (slice.alloyName === lowestMeltingPointAlloy?.materialNumber) {
                slice.widthOversize += 0.2
            }

            slice.heightOversize = FIXED_HEIGHT_OVERSIZE_SINTERING_NORMAL
        })
    }
    return slices
}

export function getWidthOversize(ringWidth: number, slices: Slice[], profile: Profile.SinterringAxial | Profile.Sinterring): number {
    if (profile === Profile.SinterringAxial) {
        return ringWidth + FIXED_WIDTH_OVERSIZE_AXIAL
    }

    return ringWidth + sumBy(slices, (slice) => slice.widthOversize || 0)
}

export function getHeightOversize(ringHeight: number, _slices: Slice[], profile: Profile.SinterringAxial | Profile.Sinterring): number {
    if (profile === Profile.SinterringAxial) {
        return ringHeight
    }

    return ringHeight + FIXED_HEIGHT_OVERSIZE_SINTERING_NORMAL
}

export function getDiameterOversize(diameter: number, profile: Profile.SinterringAxial | Profile.Sinterring): number {
    if (profile === Profile.SinterringAxial) {
        return 0
    }

    return diameter - FIXED_HEIGHT_OVERSIZE_SINTERING_NORMAL
}

export function getAxialSlices(slices: Slice[]): { innerSlice: Slice; outerSlice: Slice } {
    return { innerSlice: slices[1], outerSlice: slices[0] }
}

export function getSliceDiameters(ringDiameter: number, slices: Slice[], profile: Profile.SinterringAxial | Profile.Sinterring) {
    if (profile === Profile.Sinterring) {
        return slices.map((_) => ringDiameter)
    }

    const { innerSlice } = getAxialSlices(slices)
    return [ringDiameter + innerSlice.size * 2, ringDiameter]
}
